export default __webpack_public_path__ + "static/media/cross_error.d33f4ad8.svg";